document.addEventListener("DOMContentLoaded", () => {

    /* ==========================
       Desktop Accordion
    ========================== */

    if (window.innerWidth > 767) {

        const wrapper = document.querySelector(".desktop-accordion");

        if (wrapper) {

            const items = wrapper.querySelectorAll(".login-accordion-item");

            let current = 0;
            let interval = null;

            function setActive(index) {

                items.forEach(item => item.classList.remove("active"));

                items[index].classList.add("active");

                current = index;
            }

            function startAuto() {

                stopAuto();

                interval = setInterval(() => {

                    current = (current + 1) % items.length;

                    setActive(current);

                }, 3500);

            }

            function stopAuto() {

                if (interval) {
                    clearInterval(interval);
                    interval = null;
                }

            }

            // Hover → active immediately
            items.forEach((item, index) => {

                item.addEventListener("mouseenter", () => {

                    stopAuto();

                    setActive(index);

                });

            });

            // Resume autoplay
            wrapper.addEventListener("mouseleave", () => {

                startAuto();

            });

            setActive(0);
            startAuto();

        }

    }

    /* ==========================
       Mobile Swiper
    ========================== */

    if (window.innerWidth <= 767 && document.querySelector(".loginAccordionMobile")) {

        new Swiper(".loginAccordionMobile", {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            speed: 700,
            grabCursor: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            }
        });

    }

});